import { defineStore } from 'pinia';

/**
 * @typedef {'info' | 'error' | 'success' | 'warning' | null} MessageType
 */

/**
 * @typedef {Object} TrackingError
 * @property {string} [id] - The error identifier code (e.g., 'PARCEL-404')
 * @property {string} [reason] - A human-readable description of the error
 * @property {null|any} [payload] - Additional data related to the error, null if no data is available
 */

/**
 * @typedef {Object} AlertState
 * @property {TrackingError | string} msg - The message object
 * @property {MessageType} type - The type of message
 * @property {boolean} modal - The type of modal
 * @property {number} revision - Incremented whenever a new alert is set
 */

export const useAlertStore = defineStore('alert', {
  /**
   * @returns {AlertState}
   */
  state: () => ({
    msg: undefined,
    type: null,
    modal: false,
    revision: 0
  }),
  getters: {
    message(state) {
      return {
        msg: state.msg,
        type: state.type,
        modal: state.modal
      };
    }
  },
  actions: {
    /**
     * Set a new alert
     * @param {TrackingError | string} msg - The alert message object|string
     * @param {MessageType} type - The alert type
     * @param {boolean} modal - If the alert is in a modal or not
     */
    setAlert(msg, type, modal = false) {
      this.msg = msg;
      this.type = type;
      this.modal = modal;
      this.revision += 1;
    },
    clearAlert() {
      if (this.type) {
        this.msg = {};
        this.type = null;
        this.modal = false;
      }
    }
  }
});
